import scrollFrame from "../../setup/js/_scrollFrame.2";
import scrollWatch from "../../setup/js/_scrollWatch.2";
$(document).on(
  "revelation_assassin_update rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    $this.find(".animate__repeat-1").each(function () {
      var elementId = "#" + $(this).attr("id");
      var elementAnimate = $(this).attr("data-animate");
      scrollWatch.init({
        el: elementId,
        options: {
          watch: elementId,
          scrollThrottle: 100,
          onElementInView: function () {
            $(elementId).addClass("animate__animated");
            $(elementId).addClass(elementAnimate);
            setTimeout(function () {
              $(elementId).removeClass("animate__animated");
              $(elementId).removeClass(elementAnimate);
            }, 3000);
          },
          onElementOutOfView: function () {
            $(elementId).removeClass("animate__animated");
            $(elementId).removeClass(elementAnimate);
          },
        },
      });
    });
  }
);
